export const TRACK_PROGRESS_BUTTON = 'track_your_progress_button';
export const VIEW_PROGRESS_DETAILS_BUTTON = 'view_progress_details_button';
export const TRACK_PROGRESS_CTA = 'track_your_progress_cta';
export const TRACK_PROGRESS_CTA_LEARNER_HOME_PAGE = 'track_your_progress_cta_learner_home';
export const TRACK_PROGRESS_TRIAL_DISCLAIMER_LINK = 'track_your_progress_trial_disclaimer_link';
export const ADMISSION_DETAILS_BUTTON = 'admission_details_button';
export const DEGREE_SELECTION_DIALOG_CONTINUE_BUTTON = 'degree_selection_dialog_continue_button_link';
export const PLAN_FOR_GRADUATION_BUTTON = 'plan_for_graduation_button';
export const VIEW_PLAN_BUTTON = 'view_plan_button';
export const ADD_TO_PLAN_BUTTON = 'course_add_to_plan';
export const ADD_TERM_TO_PLAN = 'add_terms_to_plan';
